import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideList = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 5h.01M3 12h.01M3 19h.01M8 5h13M8 12h13M8 19h13"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideList);
const Memo = memo(ForwardRef);
export default Memo;
